<template>
  <div class="d-flex align-items-center mt-0 sidebar__summary-actions gap-05">
    <button
      class="btn btn--icon-sm btn--gray"
      @click.stop="$emit('decrease', item)"
      :aria-label="`Decrease ${decodedItemName}`"
      :disabled="disabled || count <= 1"
    >
      <i class="icon icon-min"></i>
    </button>
    <span class="quantity">{{ count }}</span>
    <button
      class="btn btn--icon-sm btn--gray"
      @click.stop="$emit('increase', item)"
      :aria-label="`Increase ${decodedItemName}`"
    >
      <i class="icon icon-plus"></i>
    </button>

    <button
      class="remove"
      @click.stop="$emit('remove', item.id)"
      :aria-label="`Remove ${decodedItemName}`"
    >
      <i class="icon icon-trashbin ms-0"></i>
    </button>

    <span class="price flex-grow-1 text-end fs-1">{{
      formatPrice(item.price * count, priceFormat)
    }}</span>
  </div>
</template>

<script>
import { formatPrice } from '../utils/priceUtils.js';
import { decodeHtml } from '../utils/utils.js';

export default {
  name: 'SidebarItemActions',
  props: {
    item: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      priceFormat: {
        thousandSeparator: '.',
        decimalSeparator: ',',
        decimals: 2,
      },
    };
  },
  computed: {
    decodedItemName() {
      return decodeHtml(this.item?.name || '');
    },
  },
  methods: {
    formatPrice,
  },
};
</script>
